import React from "react";

import HeaderAdmin from "../../blocks/headerAdmin";

import {navMap} from './navMap'
function AdministrationCooperation() {
  return (
    <>
      <HeaderAdmin navMap={navMap} />
      <main />
    </>
  );
}

export default AdministrationCooperation;
